import type { PortalCompany } from './portal-api.js';

/// O preço e a duração do serviço na unidade escolhida; sem unidade, os do serviço.
export function portalServiceTerms(
  service: PortalCompany['services'][number],
  unitId: string | null | undefined,
): { durationMinutes: number; priceCents: number } {
  const own = unitId ? service.units?.find((unit) => unit.businessUnitId === unitId) : undefined;
  return {
    durationMinutes: own?.durationMinutes ?? service.durationMinutes,
    priceCents: own?.priceCents ?? service.priceCents,
  };
}

/// "60 minutos · R$ 100,00", ou a faixa entre os profissionais da unidade: "60 a 90 minutos · a
/// partir de R$ 100,00" (ADR 0074, decisão 12).
export function portalServiceLabel(
  service: PortalCompany['services'][number],
  unitId: string | null | undefined,
): string {
  const terms = portalServiceTerms(service, unitId);
  const range = unitId ? service.units?.find((unit) => unit.businessUnitId === unitId) : undefined;
  const money = (cents: number) =>
    new Intl.NumberFormat('pt-BR', { style: 'currency', currency: service.currency }).format(
      cents / 100,
    );
  const duration =
    range?.minDurationMinutes !== undefined && range.minDurationMinutes !== range.maxDurationMinutes
      ? `${range.minDurationMinutes} a ${range.maxDurationMinutes} minutos`
      : `${range?.minDurationMinutes ?? terms.durationMinutes} minutos`;
  const price =
    range?.minPriceCents !== undefined && range.minPriceCents !== range.maxPriceCents
      ? `a partir de ${money(range.minPriceCents)}`
      : money(range?.minPriceCents ?? terms.priceCents);
  return `${duration} · ${price}`;
}
